import styled from "styled-components";
export const ProposalOnBoarding = styled.div `
  width: auto;
  height: auto;
  text-align: center;
`;
//# sourceMappingURL=proposal-on-boarding.styled.js.map